import { useMemo } from "react";

import { useUser } from "@components/user-context";

import { stepIsVisible, Steps } from "../steps";

type Steps = (typeof Steps.values)[number];

export function useOnboardingStep() {
  const { user } = useUser();

  const { stepDictionary, inversetStepDict } = useMemo(() => {
    const _inversetStepDict: { [index: number]: { step: Steps } } = {};
    const stepDict = Steps.data
      .filter((step: any) => step.navConfig && stepIsVisible(step, user))
      .reduce((acc, step, index) => {
        _inversetStepDict[index + 1] = { step: step.value };
        acc[step.value] = { index: index + 1 };
        return acc;
      }, {} as { [stepName in Steps]: { index: number } });

    return { stepDictionary: stepDict, inversetStepDict: _inversetStepDict };
  }, [user]);

  return { stepDictionary, inversetStepDict };
}
